<ng-container *transloco="let tr; prefix: 'dictionaries'; scope: 'dictionaries'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{ tr('title') }}</nz-page-header-title>
      <nz-page-header-subtitle>{{ tr('subTitle') }}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{ 'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{ tr('filter.query') }}</small>
          <input nz-input [(ngModel)]="params.query" (ngModelChange)="applyFilters(500)">
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="title">{{ tr('column.title') }}</th>
      <th nzColumnKey="key">{{ tr('column.key') }}</th>
      <th nzColumnKey="description">{{ tr('column.description') }}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle': 'minus-circle'" [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.title | uiLabel }}
      </td>
      <td>{{ data.key }}</td>
      <td>{{ data.description }}</td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/entries'" nz-button nzType="primary">
            <i nz-icon nzType="bars" nzTheme="outline"></i>
          </a>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
